import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

export function useIsPlaidLayerEnabled(): boolean {
  const { institution } = useGetInstitutionQuery();

  return !!institution.plaid_api_layer_template_id;
}
